// import React, { useEffect, useState } from "react";
// import { Modal, ModalHeader, ModalBody, Input } from "reactstrap";
// import MapPicker from "./MapPicker";
// import { debounce } from "lodash";

// interface GoogleMapModalProps {
//   isOpen: boolean;
//   toggle: () => void;
//   validation: any;
//   GOOGL_API_KEY: string;
//   addressInput: string;
//   setSelected: (coords: { lat: number; lng: number }) => void;
//   setSelectedPlace: (place: { name: string }) => void;
//   selected: { lat: number; lng: number } | null; //add this
// }

// const DEFAULT_LOCATION = { lat: 28.6139, lng: 77.209 }; // Delhi

// const getAddressComponents = (place: google.maps.GeocoderResult) => {
//   const components: any = {};
//   place.address_components.forEach(component => {
//     if (component.types.includes("postal_code")) components.pincode = component.long_name;
//     if (component.types.includes("locality")) components.city = component.long_name;
//     if (component.types.includes("administrative_area_level_2")) components.district = component.long_name;
//     if (component.types.includes("administrative_area_level_1")) components.state = component.long_name;
//     if (component.types.includes("route") || component.types.includes("sublocality")) {
//       components.address = component.long_name;
//     }
//   });
//   return components;
// };

// const GoogleMapModal: React.FC<GoogleMapModalProps> = ({
//   isOpen,
//   toggle,
//   validation,
//   GOOGL_API_KEY,
//   addressInput,
//   setSelected,
//   setSelectedPlace,
//   selected, //  use this
// }) => {
//     const [mapCenter, setMapCenter] = useState(DEFAULT_LOCATION);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [tempLatLng, setTempLatLng] = useState<{ lat: number; lng: number } | null>(null);
//     const [tempAddress, setTempAddress] = useState<string | null>(null);





//     useEffect(() => {
//       if (!isOpen) return;

//       const initializeMap = async () => {
//         if (addressInput?.trim()) {
//           setSearchQuery(addressInput);
//           await geocodeAddress(addressInput);
//         } else if (selected) {
//           setMapCenter(selected);
//         } else {
//           try {
//             const coords = await getCurrentLocation();
//             setMapCenter(coords);
//           } catch (err) {
//             console.warn("Failed to get user location:", err);
//           }
//         }
//       };

//       initializeMap();
//     }, [isOpen, addressInput,selected]);







//     //Current Location on only map DONE
//     const getCurrentLocation = (): Promise<{ lat: number; lng: number }> => {
//       return new Promise((resolve, reject) => {
//         if (!navigator.geolocation) {
//           reject("Geolocation not supported.");
//         } else {
//           navigator.geolocation.getCurrentPosition(
//             (position) => {
//               const coords = {
//                 lat: position.coords.latitude,
//                 lng: position.coords.longitude,
//               };  
//               setMapCenter(coords); // center the map visually only
//               resolve(coords);      // return coords for use after OK
//             },
//             (error) => {
//               console.error("Geolocation error:", error);
//               reject(error);
//             }
//           );
//         }
//       });
//     };








//     // Get Address and Update
//     const geocodeAddress = async (address: string) => {
//         try {
//         const response = await fetch(
//             `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${GOOGL_API_KEY}`
//         );
//         const data = await response.json();

//         if (data?.results?.length) {
//             const location = data.results[0].geometry.location;
//             setMapCenter(location);   //  center map to geocoded lat/lng
//             setTempLatLng(location);  // Temporarily save
//             setTempAddress(address);  //  Temporarily save            
//         }
//          else {
//             console.log("Address Not Found");
//         }
//         } catch (err) {
//         console.error("Geocoding failed:", err);
//         alert("Failed to fetch location.");
//         }
//     };









//     // When On Move Map Locate Upadate field

//   const reverseGeocode = async (lat: number, lng: number) => {
//   try {
//     const response = await fetch(
//       `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGL_API_KEY}`
//     );
//     const data = await response.json();

//     if (!data?.results?.length) return;

//     let selectedPlace = data.results.find((place: any) =>
//       place.address_components.some((comp: any) => comp.types.includes("postal_code"))
//     ) || data.results[0]; // fallback to first result if no postal_code

//     const address = selectedPlace.formatted_address || "";
//     validation.setFieldValue("address", address);

//     const components = getAddressComponents(selectedPlace);
//     if (components.city) validation.setFieldValue("city", components.city);
//     if (components.district) validation.setFieldValue("district", components.district);
//     if (components.state) validation.setFieldValue("state", components.state);
//     if (components.pincode) validation.setFieldValue("pincode", components.pincode);
//   } catch (error) {
//     console.error("Reverse geocoding failed:", error);
//   }
// };










//     // On Map Locate
//     const handleMapSelect = async (location: { lat: number; lng: number }) => {
//       try {
//         const { lat, lng } = location;
//         const response = await fetch(
//           `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGL_API_KEY}`
//         );
        
//         const data = await response.json();
//         const address = data?.results?.[0]?.formatted_address || "";
//         console.log(location,address,"in Ha");
        
//         setTempLatLng(location); // Temporarily save
//         setTempAddress(address); // Temporarily save
//       } catch (err) {
//         console.error("Reverse geocode failed on map drag:", err);
//       }
//     };

//     // Search
//     // const handleSearch = useCallback(
//     //     debounce((query: string) => {
//     //     if (query.trim()) {
//     //       geocodeAddress(query);
//     //     }
//     //     }, 600),
//     //     []
//     // );

//     const handleSearch = debounce((query: string) => {
//     if (query.trim()) {
//       geocodeAddress(query);
//     }
//   }, 600);










//     // Input
//     const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const value = e.target.value;
//         setSearchQuery(value);
//         handleSearch(value);
//     };












//   return (
//     <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
//       <ModalHeader toggle={toggle}>
//         <Input
//           type="text"
//           className="form-control"
//           placeholder="Search location..."
//           value={searchQuery}
//           onChange={handleInputChange}
//         />
//       </ModalHeader>
//       <ModalBody>
//         <div className="d-flex flex-column gap-3">
//         <MapPicker
//             apiKey={GOOGL_API_KEY}      //API KEY
//             center={mapCenter}          //Update Location
//             onSelect={handleMapSelect}  //Map Locate
//         />
//         <div className="d-flex justify-content-end">
//           <button
//             className="btn btn-primary" 
//             // onClick={toggle}
//             onClick={async () => {
//               if (tempLatLng) {
//                 setSelected(tempLatLng);
//                 setSelectedPlace({ name: tempAddress || "Selected location" });
//                 validation.setFieldValue("latitude", tempLatLng.lat);
//                 validation.setFieldValue("longitude", tempLatLng.lng);
//                 validation.setFieldValue("address", tempAddress || "");
//                 await reverseGeocode(tempLatLng.lat, tempLatLng.lng);
//               } else {
//                 const coords = await getCurrentLocation(); // ✅ only get location, don’t set fields yet
//                 setSelected(coords); // set temporarily
//                 validation.setFieldValue("latitude", coords.lat);
//                 validation.setFieldValue("longitude", coords.lng);
//                 await reverseGeocode(coords.lat, coords.lng);
//               }
//               toggle();
//             }}
//           >
//             OK
//           </button>
//         </div>
//       </div>
//       </ModalBody>
//     </Modal>
//   );
// };

// export default GoogleMapModal;



import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Input } from "reactstrap";
import MapPicker from "./MapPicker";
import { debounce } from "lodash";

interface GoogleMapModalProps {
  isOpen: boolean;
  toggle: () => void;
  validation: any;
  GOOGL_API_KEY: string;
  addressInput: string;
  setSelected: (coords: { lat: number; lng: number }) => void;
  setSelectedPlace: (place: { name: string }) => void;
  selected: { lat: number; lng: number } | null;
}

const DEFAULT_LOCATION = { lat: 28.6139, lng: 77.209 }; // Delhi

const getAddressComponents = (place: google.maps.GeocoderResult) => {
  const components: any = {};
  place.address_components.forEach(component => {
    if (component.types.includes("postal_code")) components.pincode = component.long_name;
    if (component.types.includes("locality")) components.city = component.long_name;
    if (component.types.includes("administrative_area_level_2")) components.district = component.long_name;
    if (component.types.includes("administrative_area_level_1")) components.state = component.long_name;
    if (component.types.includes("route") || component.types.includes("sublocality")) {
      components.address = component.long_name;
    }
  });
  return components;
};

const GoogleMapModal: React.FC<GoogleMapModalProps> = ({
  isOpen,
  toggle,
  validation,
  GOOGL_API_KEY,
  addressInput,
  setSelected,
  setSelectedPlace,
  selected
}) => {
  const [mapCenter, setMapCenter] = useState(DEFAULT_LOCATION);
  const [searchQuery, setSearchQuery] = useState("");
  const [tempLatLng, setTempLatLng] = useState<{ lat: number; lng: number } | null>(null);
  const [tempAddress, setTempAddress] = useState<string | null>(null);

  useEffect(() => {
    if (!isOpen) return;

    const initializeMap = async () => {
      if (addressInput?.trim()) {
        setSearchQuery(addressInput);
        await geocodeAddress(addressInput);
      } else if (selected) {
        setMapCenter(selected);
      } else {
        try {
          const coords = await getCurrentLocation();
          setMapCenter(coords);
        } catch (err) {
          console.warn("Failed to get user location:", err);
        }
      }
    };

    initializeMap();
  }, [isOpen, addressInput, selected]);

  const getCurrentLocation = (): Promise<{ lat: number; lng: number }> => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject("Geolocation not supported.");
      } else {
        navigator.geolocation.getCurrentPosition(
          position => {
            const coords = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            setMapCenter(coords);
            resolve(coords);
          },
          error => {
            console.error("Geolocation error:", error);
            reject(error);
          }
        );
      }
    });
  };

  const geocodeAddress = async (address: string) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${GOOGL_API_KEY}`
      );
      const data = await response.json();

      if (data?.results?.length) {
        const location = data.results[0].geometry.location;
        setMapCenter(location);
        setTempLatLng(location);
        setTempAddress(address);
      } else {
        console.log("Address Not Found");
      }
    } catch (err) {
      console.error("Geocoding failed:", err);
      alert("Failed to fetch location.");
    }
  };

  const reverseGeocode = async (lat: number, lng: number) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGL_API_KEY}&language=en`
      );
      const data = await response.json();

      if (!data?.results?.length) return;

      const selectedPlace =
        data.results.find((place: any) =>
          place.address_components.some((comp: any) => comp.types.includes("postal_code"))
        ) || data.results[0];

      const address = selectedPlace.formatted_address || "";
      validation.setFieldValue("address", address);

      const components = getAddressComponents(selectedPlace);
      if (components.city) validation.setFieldValue("city", components.city);
      if (components.district) validation.setFieldValue("district", components.district);
      if (components.state) validation.setFieldValue("state", components.state);
      if (components.pincode) validation.setFieldValue("pincode", components.pincode);
    } catch (error) {
      console.error("Reverse geocoding failed:", error);
    }
  };

  const handleMapSelect = async (location: { lat: number; lng: number }) => {
    try {
      const { lat, lng } = location;
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGL_API_KEY}&language=en`
      );

      const data = await response.json();
      const address = data?.results?.[0]?.formatted_address || "";
      setTempLatLng(location);
      setTempAddress(address);
    } catch (err) {
      console.error("Reverse geocode failed on map drag:", err);
    }
  };

  const handleSearch = debounce((query: string) => {
    if (query.trim()) {
      geocodeAddress(query);
    }
  }, 600);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    handleSearch(value);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>
        <Input
          type="text"
          className="form-control"
          placeholder="Search location..."
          value={searchQuery}
          onChange={handleInputChange}
        />
      </ModalHeader>
      <ModalBody>
        <div className="d-flex flex-column gap-3">
          <MapPicker
            apiKey={GOOGL_API_KEY}
            center={mapCenter}
            onSelect={handleMapSelect}
          />
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-primary"
              onClick={async () => {
                const coords = tempLatLng || (await getCurrentLocation());
                setSelected(coords);
                validation.setFieldValue("latitude", coords.lat);
                validation.setFieldValue("longitude", coords.lng);

                const addr = tempAddress || "";
                validation.setFieldValue("address", addr);
                setSelectedPlace({ name: addr || "Selected location" });
                await reverseGeocode(coords.lat, coords.lng);
                toggle();
              }}
            >
              OK
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default GoogleMapModal;
